import script from "./detailsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./detailsView.vue?vue&type=script&setup=true&lang=ts"

import "./detailsView.vue?vue&type=style&index=0&id=1e1c814e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e1c814e"]])

export default __exports__